<template>
  <heade
      id="header-wrapper"
      class="bg-gray-800 relative flex justify-center items-center gap-x-2.5 py-4"
  >
    <img
        :src="logo"
        id="logo"
        alt="Logo"
        class="h-[150px] absolute left-[60px] -top-2.5 z-[10000]"
    />
    <h1 class="text-heading font-heading text-2xl text-neutral-50 highVoltage">
      Ausbildungsplatzbörse
    </h1>
  </heade>
</template>

<script setup>
import logoSrc from '@/assets/wir-gastfreunde-logo.png';

const logo = logoSrc;
</script>

<style scoped>
@import "@/styles/textStyle.css";
</style>
